import styled from 'styled-components';

export const ItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	overflow: auto;
	padding: 1.6rem;
`;
